<template>
  <div class="review-detail">
    <div class="container">
      <div class="left">
        <div class="paper">
          <div class="title-row">
            <h3 class="title">{{ info.examTitle }}</h3>
            <p class="num">切屏次数：{{ info.leave }}</p>
          </div>

          <div class="questions">
            <div
              class="one"
              :class="{
                showObj:
                  show &&
                  (item.type == 'RADIO' ||
                    item.type == 'CHECKBOX' ||
                    item.type == 'BOOLEAN'),
                subjective: item.type == 'SUPPLY' || item.type == 'ANSWER',
              }"
              v-for="(item, idx) in info.questionList"
              :key="item.questionId"
            >
              <p class="stem" :class="'one-' + item.questionId">
                <span class="index">{{ idx + 1 }}.</span>
                <span class="type"
                  >({{ checkType(item.type) }},{{ item.score }}分)</span
                >
                {{ item.question }}
              </p>
              <!-- 多选/单选/判断 -->
              <div
                class="options"
                v-if="
                  item.type == 'RADIO' ||
                  item.type == 'CHECKBOX' ||
                  item.type == 'BOOLEAN'
                "
              >
                <p
                  class="option"
                  v-for="option in item.optionList"
                  :key="option.tag"
                >
                  <span class="tag">{{ option.tag }}.</span>
                  <span class="text">{{ option.option }}</span>
                </p>
              </div>
              <div class="answer">
                <div class="score" style="text-align: right">
                  得分:
                  <el-input-number
                    v-if="item.type == 'ANSWER' || item.type == 'SUPPLY'"
                    style="width: 50px"
                    v-model="item.userScore"
                    size="small"
                    :max="item.score"
                    :controls="false"
                  ></el-input-number>
                  <b v-else>{{
                    (item.userScore = item.userRight ? item.score : 0)
                  }}</b>
                  分
                </div>
                <div class="student-answer">
                  <b>学生答案：</b>
                  <div
                    v-if="item.type == 'SUPPLY'"
                    style="display: inline-block; vertical-align: top"
                  >
                    <p v-for="(answer, i) in item.myAnswerList" :key="i">
                      第{{ i + 1 }}空：{{ answer }}
                    </p>
                  </div>
                  <span v-else>{{
                    [...item.myAnswerList].sort().join(",")
                  }}</span>
                </div>

                <div class="right-answer">
                  <b>正确答案：</b>
                  <div
                    v-if="item.type == 'SUPPLY'"
                    style="display: inline-block; vertical-align: top"
                  >
                    <p v-for="(answer, i) in item.answerList" :key="i">
                      第{{ i + 1 }}空：{{ answer }}
                    </p>
                  </div>
                  <span v-else>{{
                    [...item.answerList].sort().join(",")
                  }}</span>
                </div>

                <div class="comment" v-show="item.type == 'ANSWER'">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 3 }"
                    resize="none"
                    placeholder="请输入批语"
                    v-model="item.questionMemo"
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="top-info">
          <el-avatar
            :size="66"
            :src="info.avatar"
            fit="cover"
            @error="errorHandler"
          ></el-avatar>
          <div class="info">
            <p class="name">{{ info.nickName }}</p>
            <p class="sno">{{ info.sno }}</p>
          </div>
        </div>
        <div class="bottom-questionIdx">
          <el-checkbox v-model="show" style="margin: 15px 0"
            >显示客观题</el-checkbox
          >
          <div class="idxs">
            <p
              class="idx"
              :class="{
                active: activeBtn == item.questionId,
                reviewed: item.userScore != null,
                showObj:
                  show &&
                  (item.type == 'RADIO' ||
                    item.type == 'CHECKBOX' ||
                    item.type == 'BOOLEAN'),
                subjective: item.type == 'SUPPLY' || item.type == 'ANSWER',
              }"
              v-for="(item, idx) in info.questionList"
              :key="item.questionId"
              @click="goAnchor('.one-' + item.questionId, item.questionId)"
            >
              {{ idx + 1 }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-row">
      <div style="width: 1200px; margin: 0 auto">
        总分:
        <el-input-number
          style="width: 70px"
          v-model="totalScore"
          size="small"
          :controls="false"
        ></el-input-number>
        分

        <p style="display: inline-block; margin-left: 20px">
          客观题得分: {{ oTotalScore }} 分
        </p>
        <div class="btns">
          <el-button
            type="primary"
            size="medium"
            round
            plain
            @click="handelBack"
            >打回重做</el-button
          >
          <span>|</span>
          <el-button
            type="primary"
            size="medium"
            round
            @click="handleSubmit(false)"
            >提交</el-button
          >
          <el-button
            type="primary"
            size="medium"
            round
            @click="handleSubmit(true)"
            >提交并进入下一份</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reviewInfo, submitReview, reviewBack } from "@/api/exam";
import { checkType } from "@/utils/index";
export default {
  data() {
    return {
      checkType,
      info: {
        questionList: [],
      },
      show: false,
      activeBtn: 0,
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    totalScore: {
      get() {
        return this.info.questionList.reduce((prev, curr) => {
          return (curr.userScore || 0) + prev;
        }, 0);
      },
      set(val) {
        // console.log(val);
        this.sTotal = val;
      },
    },
    oTotalScore() {
      let arr = this.info.questionList.filter((item) => {
        return (
          item.type == "RADIO" ||
          item.type == "CHECKBOX" ||
          item.type == "BOOLEAN"
        );
      });
      return arr.reduce((prev, curr) => {
        return (curr.userScore || 0) + prev;
      }, 0);
    },
  },
  methods: {
    getInfo() {
      this.$loading.show();
      reviewInfo(this.$route.query.receiveId).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.info = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    goAnchor(selector, index) {
      this.activeBtn = index;
      this.$el.querySelector(selector).scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    errorHandler() {
      return true;
    },
    handleSubmit(next) {
      let obj = { memo: "", rqList: [], score: this.sTotal || this.totalScore };

      this.info.questionList.forEach((item) => {
        let rq = {};
        rq.right = item.userScore ? true : false;
        rq.score = item.userScore;
        rq.questionId = item.questionId;
        rq.memo = item.questionMemo;
        obj.rqList.push(rq);
      });

      this.$loading.show();
      submitReview({ receiveId: this.$route.query.receiveId, rList: obj }).then(
        ({ code, data, msg }) => {
          this.$loading.hide();
          if (code == 0) {
            if (next && !data) {
              this.$message({
                message: "已批阅至最后一份",
                type: "warning",
                onClose: () => {
                  this.handleClose();
                },
              });
            } else if (!next) {
              this.$message({
                message: "批阅完成",
                type: "success",
                onClose: () => {
                  this.handleClose();
                },
              });
            } else {
              this.$message.success("批阅完成");
              this.$router.push({
                path: "/classCourse/exam/review/detail",
                query: {
                  ...this.$route.query,
                  receiveId: data,
                },
              });
              this.getInfo();
            }
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    // 打回
    handelBack() {
      this.$confirm("确定要打回学生试卷吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          reviewBack(this.$route.query.receiveId).then(({ code, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              this.$message({
                message: "已成功打回",
                type: "success",
                onClose: () => {
                  this.handleClose();
                },
              });
            } else {
              this.$message.error(msg);
            }
          });
        })
        .catch(() => {});
    },
    handleClose() {
      localStorage.setItem("isRefresh", true);
      window.close();
    },
  },
};
</script>

<style lang="less" scoped>
.review-detail {
  padding-top: 0 !important;
  background-color: rgb(248, 248, 248);
  .container {
    position: relative;
    padding: 20px 0 90px;
    min-height: calc(100vh - 20px);
    text-align: left;
  }
  .left {
    display: inline-block;
    padding: 20px;
    width: calc(100% - 300px);
    height: 100%;
    background-color: #fff;
    vertical-align: top;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .paper {
      padding: 0 20px;
      .title-row {
        margin-top: 10px;
        overflow: hidden;
        .title {
          float: left;
        }
        .num {
          float: right;
          color: #ff0000;
        }
      }
      .questions {
        &.type-sort {
          .type-title {
            &:first-child {
              margin-top: 20px;
            }
          }
        }
        .one {
          margin: 20px 0;
          display: none;
          &.subjective {
            display: block;
          }
          &.showObj {
            display: block;
          }

          .stem {
            color: #303133;
            .type {
              margin: 0 5px;
              color: #909399;
            }
          }
          .options {
            .option {
              margin-top: 15px;
              color: #303133;
              .tag {
                margin-right: 5px;
              }
            }
          }
          .answer {
            position: relative;
            margin-top: 15px;
            padding: 16px 20px;
            background: #f8f9fa;
            border: solid #f0f3f7 1px;
            border-radius: 3px;
            ::v-deep .score {
              position: absolute;
              top: 16px;
              right: 20px;
              b {
                color: #f56c6c;
              }
              .el-icon-check,
              .el-icon-close {
                font-size: 16px;
                font-weight: bold;
              }
            }
            .student-answer {
              margin-bottom: 10px;
              max-width: 85%;
            }
            .right-answer {
              color: #00b86e;
            }
            .comment {
              margin-top: 10px;
              ::v-deep .el-textarea__inner {
                font-family: inherit;
              }
            }
          }
        }
      }
    }
  }
  .right {
    position: fixed;
    top: 20px;
    margin-left: 920px;
    padding: 20px;
    width: 280px;
    height: calc(100% - 20px - 90px);
    background-color: #fff;
    vertical-align: top;
    .top-info {
      padding-bottom: 20px;
      border-bottom: solid 1px #ddd;
      .info {
        display: inline-block;
        margin-left: 20px;
        vertical-align: top;
        .name {
          margin-top: 10px;
          font-size: 16px;
          color: #131b26;
        }
        .sno {
          margin-top: 10px;
          color: #8a8b99;
        }
      }
    }
    .bottom-questionIdx {
      .idxs {
        .idx {
          display: inline-block;
          margin-right: 13px;
          margin-bottom: 13px;
          width: 35px;
          height: 35px;
          line-height: 35px;
          background: #ffffff;
          border: solid #94c1ff 1px;
          color: #3a8bff;
          text-align: center;
          border-radius: 5px;
          display: none;
          cursor: pointer;
          &.active {
            background-color: #3a8bff !important;
            border-color: #3a8bff !important;
            color: #ffffff !important;
          }
          &.reviewed {
            background-color: #e6f0ff;
            color: #6ba9ff;
          }
          &.subjective {
            display: inline-block;
          }
          &.showObj {
            display: inline-block;
          }
        }
      }
    }
  }
  .bottom-row {
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    height: 70px;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 999;

    .btns {
      float: right;
      span {
        margin: 0 30px;
        color: #909399;
      }
    }
  }
}
</style>